import type { ReactNode } from 'react';
import { TopNav } from './TopNav';

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="app-layout">
      <TopNav />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
}
